/**
 * Application Entry Point
 * Generated by Orbital Compiler
 *
 * Theme 'kflow' is configured from the orbital schema.
 * Uses unified ThemeProvider with data-theme="name-light/dark" attribute.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { OrbitalProvider } from '@almadar/ui/providers';
import { THEMES, DEFAULT_THEME, DEFAULT_MODE } from './generated/theme-config';
import { App } from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <OrbitalProvider themes={THEMES} defaultTheme={DEFAULT_THEME} defaultMode={DEFAULT_MODE}>
      <App />
    </OrbitalProvider>
  </React.StrictMode>
);
